import { GatewayTokenModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/tokens/models/outputs/gateway-token.model';
import { HeaderContext } from '@tanstack/react-table';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export interface TokenListValidHeaderProps
  extends HeaderContext<GatewayTokenModel, GatewayTokenModel['valid']> {}

export const TokenListValidHeader = (): // props: TokenListValidHeaderProps,
ReactNode => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // RENDER ////////////////////////////////////////////////////////////////////

  return t('delmonicos-shared-sdk.outputs-token.valid');
};
